import React from "react";
import StateFilter from "../../Common/StateFilter/StateFilter";
import styles from "./BudgetStateFilter.local.scss";
import CollaboratorList from "./CollaboratorList/CollaboratorList";

function BudgetStateFilter({
  majorKey,
  configState,
  handleStateChange,
  selectedState,
  collaborators,
  collaboratorsFetching,
  collaboratorsFetched,
  handleFetchCollaborators,
  handleSelectedCollaborator
}) {
  return (
    <div className={styles.filter_container}>
      <StateFilter
        majorKey={majorKey}
        configState={configState}
        handleStateChange={handleStateChange}
        selectedState={selectedState}
        multiSelect={true}
      />

      <CollaboratorList
        collaborators={collaborators}
        selectedCollaborator={handleSelectedCollaborator}
        collaboratorsFetching={collaboratorsFetching}
        collaboratorsFetched={collaboratorsFetched}
        handleFetchCollaborators={handleFetchCollaborators}
      />
    </div>
  );
}

export default BudgetStateFilter;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/BudgetStateFilter/BudgetStateFilter.js